/** Max alerts on vehicle/driver details map. Backend max is 1000. */
export const ENTITY_DETAILS_MAP_ALERTS_LIMIT = 10000;
